
import { Observable } from '../../Observable';
import { buffer } from '../../operator/buffer';

Observable.prototype.buffer = buffer;

declare module '../../Observable' {
  interface Observable<T> {
    buffer: typeof buffer;
  }
}


// WEBPACK FOOTER //
// ../../../src/add/operator/buffer.ts